import { render, staticRenderFns } from "./WindowItem.vue?vue&type=template&id=2864f0fc&"
import script from "./WindowItem.vue?vue&type=script&lang=js&"
export * from "./WindowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports